import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=638bc6ee&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('638bc6ee')) {
      api.createRecord('638bc6ee', component.options)
    } else {
      api.reload('638bc6ee', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=638bc6ee&", function () {
      api.rerender('638bc6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8435DR4Gbw8yL/JS/imageCarousel.vue"
export default component.exports